// 共享：从 localStorage 读取当前 mongo 用户
export function getCurrentRlUser() {
  try {
    const raw = localStorage.getItem('mongo_user');
    if (!raw) return null;
    const u = JSON.parse(raw);
    const userId = u.user_id || u._id || u.id || u.userId;
    if (!userId) return null;
    return { userId, ...u };
  } catch (e) {
    return null;
  }
}
